<template>
  <div class="card float-left ml-3 card-chat-booking">
    <div class="card-body">
      <b>{{ message.text }}</b>
      <section v-if="order">
        <div ref="actionMenus" :class="{'pt-2': menuCount}">
          <!-- Received Order Section -->
          <received-order-section class="text-small" :order="order" :includeCssClass="false"/>
          <!-- Review Section -->
          <review-section class="text-small" :order="order" :includeCssClass="false"/>
          <!-- Professional Tip Section -->
          <professional-tip-section :order="order" :includeCssClass="false"/>

          <!-- Update service date time -->
          <div v-if="canBookAdditionalHours(order)">
            <hr>
            <button class="btn btn-info btn-block"
                    @click="openOrderAdditionalHoursModal(order)">
              {{ $t('message.my_reservations.book_additional_hours') }}
            </button>
          </div>

          <!-- Update service date time -->
          <div v-if="order.paid_status === 1 && order.is_no_datetime_booking === 1 && order.status === 0">
            <hr>
            <button class="btn btn-info btn-block" @click="openUpdateServiceDateTimeModal()">
              {{ $t('message.button.select_service_datetime') }}
            </button>
          </div>

          <!-- Purchase services -->
          <div v-if="order.professional_id && (parentServiceId === 2 || (parentServiceId === 1 && order.extras === 2))">
            <hr>
            <button class="btn btn-info btn-block"
                    :class="{ 'mt-2': $mq.phone }"
                    @click="openPurchaseServiceModal()">
              {{ $t('message.my_reservations.book_additional_ironing_service') }}
            </button>
          </div>
        </div>
        <hr>
        <div class="mb-3">
          #{{ order.order_code }} - <span v-html="$options.filters.serviceParentName(order.service_id, globalState.services)"></span>
        </div>
        <div class="row mb-2 no-gutters">
          <div class="col-4 text-left">
            <label>{{ $t('message.my_reservations.status') }}</label>
          </div>
          <div class="col-8 text-right">
            <span v-html="$options.filters.orderStatus(order)"></span>
          </div>
        </div>

        <div class="row mb-4 no-gutters" v-if="order.package">
          <div class="col-3 text-left text-orange">
            <i class="fal fa-layer-group"></i> {{ $t('message.my_reservations.package') }}
          </div>
          <div class="col-9 text-right">
            {{ $t('message.my_reservations.package') }} #{{ order.package.id }} - {{ order.package.package_type |
            multiLangName }}
            <span v-if="order.package.package_type.category === 'unlimited'">
              {{ $t('message.booking.new_booking.package_count', { count: order.package.orders.length }) }}
            </span>
          </div>
          <div class="col-12 text-right" v-if="order.package.package_type.category === 'unlimited'">
            <ul class="list-unstyled">
              <li v-for="(order, index) in order.package.orders">
                <span v-if="order.cleaning_date">{{ order.cleaning_date | prettyDate }}</span>
                <span class="text-orange" v-else>
                  {{ $t('message.my_reservations.booking_date_not_specified') }}
                </span>
                <span class="badge badge-pill"
                      :class="(order.status === 2) ? 'badge-success' : 'badge-warning'">
                  {{ order.status === 2 ? $t('message.my_reservations.past') : $t('message.my_reservations.upcoming') }}
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div class="row mb-2 no-gutters">
          <div class="col-4 text-left">
            <label>{{ $t('message.my_reservations.cleaning_date') }}</label>
          </div>
          <div class="col-8 text-right">
            <span v-if="order.cleaning_date">{{ order.cleaning_date | prettyDate }}</span>
            <span class="text-orange" v-else>ยังไม่ระบุวันที่รับบริการ</span>
          </div>
        </div>
        <div class="row mb-2 no-gutters">
          <div class="col-4 text-left">
            <label v-if="order.service_id === 1">{{ $t('message.my_reservations.duration') }}</label>
            <label v-else-if="order.order_service_items">{{ $t('message.service_item.list_of_items') }}</label>
            <label v-else>{{ $t('message.booking.booking_step.service') }}</label>
          </div>
          <div class="col-8 text-right">
            <span v-if="order.service_id === 1">
              {{ order.work_hour }} {{ $tc('message.hour', order.work_hour) }}
            </span>
            <span v-else-if="order.order_service_items">
              <div v-for="orderServiceItem in order.order_service_items">
                {{ orderServiceItem.service_item | multiLangName }} {{ orderServiceItem.quantity }} 
                {{ orderServiceItem.service_item.item_unit | multiLangName }}
              </div>
              <div class="text-info text-small">{{ $t('message.service_item.remark') }}</div>
            </span>
            <span v-else>
              <div v-html="$options.filters.serviceParentName(order.service_id, globalState.services)"></div>
              <div>{{ globalState.services[order.service_id] | multiLangName }}</div>
            </span>
          </div>
        </div>
        <!-- Order additional hours list -->
        <order-additional-hours ref="orderAdditionalHours" :order="order"/>

        <div class="row mb-2 no-gutters" v-if="order.professional">
          <div class="col-4 mt-2 text-left">
            <label>{{ $t('message.my_reservations.cleaner') }}</label>
          </div>
          <div class="col-8 text-right">
            <div class="d-flex justify-content-end align-items-center">
              <div>
                <img :src="order.professional.full_picture" alt="" width="40" 
                     class="rounded-circle"
                     :class="order.declined_order_data && order.status === 0 ? 'border border-danger' : ''">
              </div>
              <div class="pl-2">
                {{ order.professional_name | firstName }}
                <div class="text-small" v-if="order.status === 0 && order.cleaning_date && !order.declined_order_data">
                  <div class="-status-pending">
                    <span class="bullet-notification">
                      <i class="fas fa-circle -status-pending"></i>
                    </span>
                    {{ $t('message.my_reservations.waiting') }}
                  </div>
                </div>
                <div class="text-small" v-else-if="order.status > 0" v-html="$options.filters.professionalJobStatus(order, true)"></div>
              </div>
            </div>
          </div>
        </div>

        <!-- Declined order data -->
        <div v-if="order.declined_order_data && order.status === 0">
          <div class="row no-gutters" v-if="order.selected_professional_id">
            <div class="col-12">
              <div class="text-order-notification">
                <span class="bullet-notification">
                  <i class="fas fa-circle -status-alert"></i>
                </span>
                <span class="-status-alert">
                  {{ $t('message.declined_booking.cleaner_declined_booking') }}
                </span>
                <div class="-status-alert mt-1">
                  - {{ order.declined_order_data | declinedReason }}
                </div>
              </div>
            </div>
          </div>
          <div class="row no-gutters" v-else>
            <div class="col-4 text-left">
              <label>{{ $t('message.my_reservations.cleaner') }}</label>
            </div>
            <div class="col-8 text-primary text-right">
              {{ $t('message.my_reservations.finding_new_cleaner') }}
            </div>
          </div>
        </div>
        <!-- End declined order -->

        <!-- Pre-booking Professional Selection Section -->
        <div class="row pb-4 no-gutters" v-if="order.status === 0 && (order.pre_booking_professionals || order.declined_order_data)">
          <div class="col-12">
            <pre-booking-professional-selection-section :imgSize="48" :order="order" />
          </div>
        </div>

        <div class="row mb-2 no-gutters">
          <div class="col-4 text-left">
            <label>{{ $t('message.my_reservations.customer_name') }}</label>
          </div>
          <div class="col-8 text-right">
            {{ order.customer_name }}
          </div>
        </div>
        <div class="row mb-2 no-gutters">
          <div class="col-4 text-left">
            <label>{{ $t('message.my_reservations.customer_address') }}</label>
          </div>
          <div class="col-8 pl-3 text-left">
            <p v-if="order.place_name">{{ order.place_name }}</p>
            <p>{{ $t(globalState.placeSizes[order.place_size_id]) | multiLangName }}</p>
            <p>{{ order.address }}</p>
          </div>
        </div>
        <div class="row mb-2 no-gutters" v-if="order.has_pet || order.pet_types">
          <div class="col-4 text-left">
            <label>{{ $t('message.my_reservations.pet') }}</label>
          </div>
          <div class="col-8 text-left">
            <span v-if="order.pet_types">{{ getPetTypesResult(order) }}</span>
            <span v-if="order.pet_remark">{{ order.pet_remark }}</span>
          </div>
        </div>
        <div class="row mb-2 no-gutters" v-if="order.remark">
          <div class="col-4 text-left">
            <label>{{ $t('message.my_reservations.remark') }}</label>
          </div>
          <div class="col-8 text-left">
            {{ order.remark }}
          </div>
        </div>
        <!-- Customer area photos -->
        <div class="mb-2" v-if="order.customer_area_photos">
          <div>
            <label>{{ $t('message.booking.checkout_step.customer_area_photos') }}</label>
          </div>
          <photos-album
            :photos="order.customer_area_photos"
            :photoType="'order_photos'"
            :includeGallery="true"
          />
        </div> 
        <!-- Customer area photos -->
        <div class="mb-2" v-if="order.status === 2 && order.order_photos && order.sent_photo_status === 1">
          <div>
            <label>{{ $t('message.booking.checkout_step.completed_cleaning_photos') }}</label>
          </div>
          <photos-album
            :photos="order.order_photos"
            :photoType="'order_photos'"
            :includeGallery="true"
          />
        </div> 
        <hr>
        <div class="row my-2 no-gutters">
          <div class="col-12">
            <div>
              <label>{{ $t('message.my_reservations.payment') }}</label>
            </div>
            <order-summary-total :order="order" v-if="order"/>
          </div>
        </div>
        <div class="row no-gutters" v-if="order.professional_tip && order.professional_tip.paid_status">
          <div class="col-12">
            <hr>
          </div>
          <div class="col-6">
            <label class="mb-0">{{ $t('message.professional_tip.amount') }}</label>
          </div>
          <div class="col-6 text-right">
            {{ Number(order.professional_tip.amount) | currency }}
          </div>
        </div>
        <div class="row no-gutters" v-if="order.purchases.length > 0">
          <div class="col-12">
            <hr>
          </div>
          <div class="col-12">
            <label>{{ $t('message.my_reservations.other_payments') }}</label>
          </div>
          <div class="col-12">
            <order-purchase :order="order"/>
          </div>
        </div>
      </section>
      <hr>
      <section>
        <button class="btn btn-outline-info btn-block" @click="backToMainMenu()">กลับสู่เมนูหลัก</button>
      </section>
    </div>
    <!-- Update service date-time and professional id -->
    <select-service-date-time-modal @onUpdatedOrder="performUpdateOrder()" ref="selectServiceDateTimeModal"/>
    <!-- Purchase service -->
    <purchase-service-modal @onUpdatedOrder="performUpdateOrder()" ref="purchaseServiceModal" :parentServiceId="2"/>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import OrderPurchase from '../../order/components/OrderPurchase'
  import OrderSummaryTotal from '../../order/components/OrderSummaryTotal'
  import ProfessionalPicture from '../../professional/components/ProfessionalPicture'
  import ProfessionalTipSection from '../../order/components/ProfessionalTipSection'
  import PurchaseServiceModal from '../../order/components/PurchaseServiceModal'
  import ReceivedOrderSection from '../../order/components/ReceivedOrderSection'
  import ReviewSection from '../../order/components/ReviewSection'
  import SelectServiceDateTimeModal from '../../order/components/SelectServiceDateTimeModal'
  import OrderAdditionalHours from '../../order/components/OrderAdditionalHours'
  import PhotosAlbum from '../../order/components/PhotosAlbum'
  import PreBookingProfessionalSelectionSection from '../../order/components/PreBookingProfessionalSelectionSection'

  export default {
    props: {
      message: Object
    },
    components: {
      OrderAdditionalHours,
      OrderPurchase,
      OrderSummaryTotal,
      ProfessionalPicture,
      ProfessionalTipSection,
      PurchaseServiceModal,
      ReceivedOrderSection,
      ReviewSection,
      SelectServiceDateTimeModal,
      PhotosAlbum,
      PreBookingProfessionalSelectionSection
    },
    data () {
      return {
        order: null,
        parentServiceId: null,
        menuCount: null
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState',
        orderDetail: 'orderDetail/getOrderDetail',
        user: 'auth/getUser'
      })
    },
    watch: {
      orderDetail () {
        this.performUpdateOrder()
      }
    },
    methods: {
      ...mapActions('orderDetail', ['loadOrderDetail']),
      getPetTypesResult (order) {
        const result = order.pet_types.map(item => {
          let result = (this.$i18n.locale === 'th') ? item.name_th : item.name_en
          if (item.remark) {
            result += `: ${item.remark}`
          }
          return result
        }).join(', ')
        return result
      },
      async openOrderAdditionalHoursModal (order) {
        await this.loadOrderDetail(order.id)
        this.$refs.orderAdditionalHours.openBookAdditionalHoursModal(null)
      },
      getMenuCount () {
        if (this.$refs.actionMenus) {
          this.menuCount = this.$refs.actionMenus.childElementCount
        }
      },
      getParentServiceId () {
        this.parentServiceId = this.order.service_id
        if (this.globalState.services[this.order.service_id].parent_id > 0) {
          this.parentServiceId = this.globalState.services[this.order.service_id].parent_id
        }
      },
      performUpdateOrder () {
        if (this.orderDetail) {
          this.order = this.orderDetail
        }
      },
      canBookAdditionalHours (order) {
        if (order && order.status === 1 && !order.cancel) {
          let canBook = true
          const bookMoreHours = order.book_more_hours
          if (bookMoreHours && bookMoreHours.length > 0) {
            if (!bookMoreHours[0].status) {
              canBook = false
            }
          }
          if (this.globalState.services[this.parentServiceId].can_book_more_hours && canBook) {
            return true
          }
        }
        return false
      },
      openPurchaseServiceModal () {
        this.$refs.purchaseServiceModal.showModal(true)
      },
      openUpdateServiceDateTimeModal () {
        this.$refs.selectServiceDateTimeModal.setOrderData(this.order)
        this.$refs.selectServiceDateTimeModal.showModal(true)
      },
      backToMainMenu () {
        const action = {
          label: 'main-menu',
          text: 'กลับสู่เมนูหลัก'
        }
        this.sendMessage(action)
      },
      sendMessage (action) {
        const message = {
          sender_type: 'user',
          type: 'text',
          label: action.label,
          text: action.text,
          data: action.data
        }
        this.$store.commit('chatBooking/ADD_MESSAGE', message)
      }
    },
    async mounted () {
      this.order = this.message.data
      this.getMenuCount()
      this.getParentServiceId()
      if (this.order.id !== this.orderDetail.id) {
        await this.loadOrderDetail(this.order.id)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/chatBooking/components/OrderDetailMessage.vue